






import VueOptions from '@utils/VueOptions'

settings =
  name: "ProgressCircle"

  vue:
    props: ['progress', 'total', 'title', 'options']

    computed:
      percentage: ->
        return 0 if not @progress
        Math.round((@progress * 100) / @total)
      status: -> 'success' if @progress >= @total
      width: -> @options?.width || 50

export default VueOptions.vue settings
